module.exports = __webpack_public_path__ + "img/logout.e55d98cc.svg";